import { Company, DataResponse } from '@fcom/common/interfaces';
import { AppState } from '@fcom/core/interfaces';

export const CORPORATE_FEATURE_KEY = 'corporate';

export enum CorporateReportStatus {
  INITIAL = 'Initial',
  LOADING = 'Loading',
  READY = 'Ready',
}

export interface CorporateReportsDataState {
  [key: string]: CorporateSpendResponsePerDateRange;
}

export interface CorporateSpendResponsePerDateRange {
  [key: string]: DataResponse | string;
}

export interface CorporateReportStatusPerCorporate {
  [key: string]: CorporateReportStatusPerDateRange;
}

export interface CorporateReportStatusPerDateRange {
  [key: string]: CorporateReportStatus;
}

export interface CompanyState {
  companyDetails?: Company;
}

export interface CorporateState {
  reportStatus: CorporateReportStatusPerCorporate;
  reports: CorporateReportsDataState;
  company: CompanyState;
}

export interface CorporateFeatureState extends AppState {
  readonly [CORPORATE_FEATURE_KEY]: CorporateState;
}
